<template>
  <b-col cols="12" v-if="paginationData.totalPages >= 1">
    <div class="d-flex align-items-center justify-content-between">
      <div class="dataTables_paginate paging_simple_numbers float-start">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination
            :total-rows="paginationData.totalCount"
            :per-page="pageSize.count"
            v-model="currentPage"
            align="center"
            page-class="pagination-button-container"
            aria-controls="articles-table"
          />
        </ul>
      </div>
      <div class="d-flex flex-row-reverse align-items-center">
        <Dropdown pagination :items="dropDownListItems" @dropdownSelected="pageSizeSetter($event)" />
        <div class="me-5">تعداد کل {{ paginationData.totalCount }} عدد</div>

        <div>نمایش {{ currentPage }} از {{ paginationData.totalPages }}</div>
      </div>
    </div>
  </b-col>
</template>

<script>
import Dropdown from './Dropdown.vue'
export default {
  name: 'pagination',
  props: {
    dropDownListItems: {
      type: Array,
    },
    getData: {
      type: Function,
    },
    paginationData: {
      type: Object,
    },
    tableId: {
      type: Number,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
      flag: true,
    }
  },
  components: {
    Dropdown,
  },
  methods: {
    pageSizeSetter(item) {
      this.pageSize = item
    },
  },
  watch: {
    currentPage(newPage, oldPage) {
      if (newPage === oldPage) return
      if (newPage >= 1) {
        this.$emit('tableObj', { tableId: this.tableId, page: newPage, pageSize: this.pageSize })
      }
    },
    pageSize(newSize, oldSize) {
      if (newSize === oldSize) return
      if (newSize !== oldSize) {
        this.$emit('tableObj', { tableId: this.tableId, page: 1, pageSize: this.pageSize })
      }
    },
  },
}
</script>

<style scoped>
.dropdown-select {
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
}
</style>
